import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/share.png'


const _withScopeId = n => (_pushScopeId("data-v-d5d3b47c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "video-info" }
const _hoisted_2 = {
  key: 0,
  class: "contents"
}
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { class: "header-left" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/" }, "首页", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, "视频详情", -1))
const _hoisted_7 = { class: "contents-info" }
const _hoisted_8 = { class: "info-left" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "video-box" }, [
  /*#__PURE__*/_createElementVNode("iframe", {
    src: "//player.bilibili.com/player.html?aid=958725797&bvid=BV1fp4y1c7BS&cid=1272948253&p=1",
    scrolling: "no",
    border: "0",
    frameborder: "no",
    framespacing: "0",
    allowfullscreen: "true"
  }, "\r\n          ")
], -1))
const _hoisted_10 = { class: "jianjie" }
const _hoisted_11 = { class: "attr-p" }
const _hoisted_12 = { class: "edit-span" }
const _hoisted_13 = { class: "edit-span-share" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "edit-span-share-info" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
  /*#__PURE__*/_createTextVNode("分享")
], -1))
const _hoisted_15 = { class: "share-list" }
const _hoisted_16 = { class: "info-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_home_head = _resolveComponent("home-head")!
  const _component_current_address = _resolveComponent("current-address")!
  const _component_share = _resolveComponent("share")!
  const _component_video_info_good_list = _resolveComponent("video-info-good-list")!
  const _component_html_footer = _resolveComponent("html-footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_home_head),
    (_ctx.goodsInfo.data)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.goodsInfo.data.names), 1),
            _createVNode(_component_current_address, null, {
              address: _withCtx(() => [
                _hoisted_5,
                _createTextVNode("> "),
                _hoisted_6
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("p", _hoisted_10, [
                _createTextVNode(" 简介: "),
                _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.goodsInfo.data.content), 1),
                _createElementVNode("span", _hoisted_12, [
                  _createElementVNode("span", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_share, {
                        url: _ctx.routerPath,
                        douban: true,
                        title: _ctx.goodsInfo.data.names,
                        description: _ctx.goodsInfo.data.content
                      }, null, 8, ["url", "title", "description"])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_video_info_good_list, {
                cid: _ctx.scid,
                aid: _ctx.aid,
                sort: _ctx.sort,
                curIndex: (_ctx.goodsInfo.curIndex as number),
                nowid: _ctx.goodsInfo.data.id,
                onSedGoodsInfo: _ctx.sedGoodsInfo
              }, null, 8, ["cid", "aid", "sort", "curIndex", "nowid", "onSedGoodsInfo"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_html_footer)
  ]))
}